import React from 'react';
import styles from '@/styles/components/reports/base/GridTable.module.css';
import _ from 'lodash';

export type HeaderData = string | JSX.Element;
export interface GridTableData {
  cols: HeaderData[];
  rows: HeaderData[];
  firstCol?: HeaderData;
  wideColumn?: boolean;
  elementRenderer: (colIndex: number, rowIndex: number) => JSX.Element;
}

function getHeader(data: HeaderData): JSX.Element {
  return React.isValidElement(data) ? (
    data
  ) : (
    <span className={styles.headerText}>{data}</span>
  );
}

function getElementWrapper(
  element: JSX.Element,
  isLastRow: boolean,
  key: string
) {
  const className = isLastRow
    ? `${styles.element} ${styles.lastRow}`
    : styles.element;
  return (
    <div key={key} className={className}>
      {element}
    </div>
  );
}
export const GridTable: React.FC<GridTableData> = data => {
  return (
    <div
      className={styles.gridWrapper}
      style={{
        gridTemplateColumns: `${data.wideColumn ? '2fr' : ''} repeat(${
          data.wideColumn ? data.cols.length : data.cols.length + 1
        }, 1fr)`,
      }}
    >
      {data.firstCol && (
        <div className={styles.colHeader}>{getHeader(data.firstCol)}</div>
      )}
      {!data.firstCol && <div className={styles.colEmptyHeader}></div>}
      {_.map(data.cols, (col, colIndex) => (
        <div key={colIndex + '-header'} className={styles.colHeader}>
          {getHeader(col)}
        </div>
      ))}
      {_.map(data.rows, (row, rowIndex) => {
        const isLastRow = rowIndex === data.rows.length - 1;
        return [
          <div
            key={rowIndex + '-header'}
            className={`${styles.rowHeader} ${
              isLastRow ? styles.lastRow : ''
            } ${data.firstCol ? styles.firstCol : ''}`}
          >
            {getHeader(row)}
          </div>,
        ].concat(
          _.map(data.cols, (_col, colIndex) =>
            getElementWrapper(
              data.elementRenderer(colIndex, rowIndex),
              isLastRow,
              `${colIndex}-${rowIndex}`
            )
          )
        );
      })}
    </div>
  );
};
